export default function SuccessCircleIcon() {
  return (
    <>
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.33317 27.9998C9.33317 23.0491 11.2998 18.3012 14.8005 14.8005C18.3012 11.2998 23.0491 9.33317 27.9998 9.33317C32.9505 9.33317 37.6985 11.2998 41.1992 14.8005C44.6998 18.3012 46.6665 23.0491 46.6665 27.9998C46.6665 32.9505 44.6998 37.6985 41.1992 41.1992C37.6985 44.6998 32.9505 46.6665 27.9998 46.6665C23.0491 46.6665 18.3012 44.6998 14.8005 41.1992C11.2998 37.6985 9.33317 32.9505 9.33317 27.9998ZM27.9998 4.6665C15.1128 4.6665 4.6665 15.1128 4.6665 27.9998C4.6665 40.8868 15.1128 51.3332 27.9998 51.3332C40.8868 51.3332 51.3332 40.8868 51.3332 27.9998C51.3332 15.1128 40.8868 4.6665 27.9998 4.6665ZM40.7328 22.0662L37.4335 18.7668L25.6665 30.5338L19.1495 24.0168L15.8502 27.3162L25.6665 37.1325L40.7328 22.0662Z"
          fill="#11A75C"
        />
      </svg>
    </>
  );
}
